import { FC, useMemo } from 'react'

import { Translation } from 'cng-common/features/translations'

import { partnerBasicInfoFields } from '../../../configs'

import { FormSummaryInputs } from './components/formSummaryInputs/FormSummaryInputs'
import { IMultiLinesItem } from './components/multiLinesControl/MultiLinesControl'
import { DEFAUT_ADDITIONAL_ITEM, DEFAUT_SUMMARY_ITEMS, SPLIT_CHARACTER } from './configs'

import styles from './RetailerSummary.module.scss'

interface IRetailerSummaryProps {
  isEditMode: boolean
  initialValue: string
  labelKey: string
}

export const RetailerSummary: FC<IRetailerSummaryProps> = ({
  isEditMode,
  initialValue,
  labelKey,
}) => {
  const readonlyItems: IMultiLinesItem[] = useMemo(() => {
    const values = (initialValue ?? '').split(SPLIT_CHARACTER)

    const items: IMultiLinesItem[] = []
    DEFAUT_SUMMARY_ITEMS.forEach((defaultItem, index) => {
      const value = values.length && values.length > index ? values[index] : defaultItem.value
      items.push({ ...defaultItem, value })
    })

    if (values.length && values.length > DEFAUT_SUMMARY_ITEMS.length) {
      const defaultItemsLength = DEFAUT_SUMMARY_ITEMS.length
      values.forEach((value, index) => {
        if (index >= defaultItemsLength) {
          items.push({ ...DEFAUT_ADDITIONAL_ITEM, value })
        }
      })
    }

    return items
  }, [initialValue])

  return (
    <div className={styles.root}>
      <div className={styles.title}>
        <Translation text={labelKey} />
      </div>
      {isEditMode && (
        <FormSummaryInputs field={partnerBasicInfoFields.summary} initialValue={initialValue} />
      )}
      {!isEditMode && (
        <div className={styles.itemsList}>
          {readonlyItems.map((item, index) => (
            <div key={index} className={styles.itemContainer}>
              <div className={styles.label}>
                <Translation text={`${item.placeholder}-short`} span />
              </div>
              <div className={styles.value}>{item.value || '-'}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
